import { createFileRoute } from "@tanstack/react-router";
import KanbanBoard from "@/components/logistics/containers/kanban/kanban-board";

export const Route = createFileRoute(
  "/_authenticated/logistics/containers/_list/kanban",
)({
  component: ConsolidadosKanbanPage,
});

function ConsolidadosKanbanPage() {
  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <KanbanBoard />
    </div>
  );
}
